import actions from "./actions";

const initState = {
    readStockBalanceState: null,
    stockBalances: [],
    requestedProductId: null,
};

export default function authReducer(state = initState, action = {}) {
    const updatedLists = {};

    switch (action.type) {
        case actions.STOCK_BALANCE_READ_REQUEST:
            return {
                ...state,
                requestedProductId: action.productId || null,
                readStockBalanceState: 'request',
            };
        case actions.STOCK_BALANCE_READ_SUCCESS: {
            // Process response data
            const { responseData } = action;

            // Stock Balance
            if (responseData.stock_balances) {
                updatedLists.stockBalances = responseData.stock_balances.items;
                updatedLists.requestedProductId = responseData.stock_balances.product_id;
            }
            return {
                ...state,
                ...updatedLists,
                readStockBalanceState: 'success',
            };
        }
        default:
            return state;
    }
}
